import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { MdMoreVert } from "react-icons/md";
// import { fetchAnnouncement } from "../../../actions/career.action";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import { dateFormatterUI4 } from "../../../utils/helpers/dataHelper";

export default function CareerDetails() {
  const history = useHistory();
  const location = useLocation();
  const data = location.state;
  console.log({ data });

  useEffect(() => {}, []);

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  const compassLogo =
    "https://res.cloudinary.com/landmark-university-alumni-association/image/upload/v1657472072/Admin/favlcon_pfrtsr.png";

  return (
    <div>
      {false ? (
        <RoundLoader />
      ) : (
        <>
          <div>
            <div className="mt-10 mx-5">
              <div className="flex justify-between mb-6">
                <div className="flex cursor-pointer">
                  <AiOutlineArrowLeft
                    size={25}
                    onClick={() => history.goBack()}
                  />
                </div>
                <div className="single_line font-bold text-xl font-serif mx-2">
                  {data.name}
                </div>
                <div className="">
                  <MdMoreVert size={25} />
                </div>
              </div>
              {isObjectEmpty(data) && data === Loading.ERROR ? (
                <></>
              ) : (
                <div className="rounded w-full md:flex md:justify-between">
                  <div className="md:mr-10 md:w-1/2">
                    <img
                      className="object-fill w-full h-96"
                      src={
                        data.imageUrl === "" || data.imageUrl === null
                          ? compassLogo
                          : data.imageUrl
                      }
                      alt={data.name}
                    />
                  </div>
                  <div className="p- md:border-l md:w-1/2">
                    <div className="text-end p-2">
                      {dateFormatterUI4(data.dateCreated)}
                    </div>
                    <div className="p-4">
                      <div className="text-2xl text-center mb-2 font-bold text-green-800">
                        {data.title}
                      </div>
                      <hr />
                      <div className={`mb-5 mt-5`}>{data.description}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
